import React from "react";
import Chart from "react-apexcharts";
import { useTheme, useMediaQuery } from "@mui/material";
import { tokens } from "../../../../theme";

const ApexBarChart = ({ dataNutritionPerMeal, isDashboard }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const colors = tokens(theme.palette.mode);

  // Prepare the categories (meals) and series from your data
  const categories = dataNutritionPerMeal.map((item) => item.meal);
  const series = [
    {
      name: "protein",
      data: dataNutritionPerMeal.map((item) => item.protein),
    },
    {
      name: "carbs",
      data: dataNutritionPerMeal.map((item) => item.carbs),
    },
    {
      name: "fat",
      data: dataNutritionPerMeal.map((item) => item.fat),
    },
  ];

  const options = {
    chart: {
      type: "bar",
      toolbar: { show: false },
      animations: { enabled: true },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "55%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: true,
      style: { fontSize: isMobile ? "12px" : "15px" },
    },
    xaxis: {
      categories: categories,
      labels: {
        rotate: isMobile ? 45 : 0,
        style: {
          fontSize: isMobile ? "12px" : "15px",
          // ApexCharts accepts an array of colors for labels; here we use a single color.
          colors: [colors.grey[100]],
        },
      },
      title: {
        text: isDashboard ? "" : "Meal",
        style: {
          fontSize: isMobile ? "12px" : "15px",
          color: colors.grey[100],
        },
      },
    },
    yaxis: {
      title: {
        text: isDashboard ? "" : "g",
        style: {
          fontSize: isMobile ? "12px" : "15px",
          color: colors.grey[100],
        },
      },
      labels: {
        style: {
          fontSize: isMobile ? "12px" : "15px",
          color: colors.grey[100],
        },
      },
    },
    legend: {
      show: true,
      position: isMobile ? "bottom" : "right",
      horizontalAlign: isMobile ? "center" : "left",
      offsetY: isMobile ? 10 : 0,
      fontSize: isMobile ? "12px" : "14px",
      labels: { colors: colors.grey[100] },
    },
    grid: { borderColor: colors.grey[700] },
    tooltip: {
      theme: "dark",
      style: { fontSize: isMobile ? "12px" : "14px" },
    },
    colors: ["#1976D2", "#FFC107", "#F44336"],
    responsive: [
      {
        breakpoint: 600,
        options: {
          plotOptions: { bar: { columnWidth: "65%" } },
          legend: { position: "bottom", offsetY: 10 },
        },
      },
    ],
  };

  return <Chart options={options} series={series} type="bar" height="350" />;
};

export default ApexBarChart;
